// import config from 'config';

class Url {
  getSizedImage(photos = [], size) {
    const sized = []

    photos && photos.map(photo => {
      sized.push(this.image(photo, size))
    })

    return sized
  }
  /**
   * get url of image
   * @param {String} image image image
   * @param {Number} size image size
   */
  image(image, size) {
    if (!image || !image.url || !size)
      return null

    const format = image.url.split(".");
    const ext = format[format.length - 1]
    const fileName = format.splice(0, format.length - 1).join(".")

    const imageSize = size ? `_${size}x` : "";
    // const url = `${config.http.ecommerce.baseURL}/assets/images/${image.id}${imageSize}.${format[format.length-1]}`;
    const url = `${fileName}${imageSize}.${ext}`;

    return url;
  }

  imageExists(imageUrl) {
    var image = new Image();

    image.src = imageUrl;

    if (image.completed) {
      return true
    } else {
      return false
    }
  }
};

export default new Url();
